import React from 'react';
import OdezaAppStandalone from 'odeza-customer-chat-core/src/OdezaAppStandalone';
import { config } from './config';
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {
	MERCY_HEALTH,
	QUEUE_NAME_BON_SECOURS_ORDERS,
	QUEUE_NAME_BON_SECOURS_SERVICE,
	QUEUE_NAME_MERCY_HEALTH_ORDERS,
	QUEUE_NAME_MERCY_HEALTH_SERVICE
} from "./constants";

import logoBS from "./images/bon_secours_logo.png";
import avatarBS from "./images/bon_secours_small_logo.png";
import logoMH from "./images/mercy_health_logo.png";
import avatarMH from "./images/mercy_health_small_logo.png";

function App() {

	const customRoutes = [
		{route: '/BonSecours-CustomerService', startQueueName: QUEUE_NAME_BON_SECOURS_SERVICE},
		{route: '/BonSecours-Orders', startQueueName: QUEUE_NAME_BON_SECOURS_ORDERS},
		{route: '/MercyHealth-CustomerService', startQueueName: QUEUE_NAME_MERCY_HEALTH_SERVICE},
		{route: '/MercyHealth-Orders', startQueueName: QUEUE_NAME_MERCY_HEALTH_ORDERS},
	];

	const setLogosByQueue = (config, queueName) => {
		if (queueName.indexOf(MERCY_HEALTH) !== -1) {
			config.chatLogo = logoMH;
			config.avatarUrl = avatarMH;
		} else {
			config.chatLogo = logoBS;
			config.avatarUrl = avatarBS;
		}
	};

	const getStyleByQueue = (config, queueName) => {
		if (queueName.indexOf(MERCY_HEALTH) !== -1) {
			return <style>
				{
					".template__href," +
					".endChatButton," +
					".endLiveChatButton," +
					".appointment-button," +
					".ask_name button {" +
					"  background-color: #0072bc !important;" +
					"}" +
					".slick-prev:before, .slick-next:before {" +
					"  color: #0072bc !important;" +
					"}" +
					".sendMessage polygon#Path {" +
					"  stroke: #0072bc !important;" +
					"  fill: #0072bc !important;" +
					"}" +
					".btn_start_over," +
					".go_back_button {" +
					"  color: #0072bc !important;" +
					"  background-color: unset !important;" +
					"}"
				}
			</style>
		} else {
			return <style>
				{
					".template__href," +
					".endChatButton," +
					".endLiveChatButton," +
					".appointment-button," +
					".ask_name button {" +
					"  background-color: #0054a6 !important;" +
					"}" +
					".slick-prev:before, .slick-next:before {" +
					"  color: #0054a6 !important;" +
					"}" +
					".sendMessage polygon#Path {" +
					"  stroke: #0054a6 !important;" +
					"  fill: #0054a6 !important;" +
					"}" +
					".btn_start_over," +
					".go_back_button {" +
					"  color: #0054a6 !important;" +
					"  background-color: unset !important;" +
					"}"
				}
			</style>
		}
	}

	return (
		<Router>
			<Switch>
				{/* --- Custom routes --- */}
				{
					customRoutes.map((record, key) => {
						return <Route key={key} path={process.env.PUBLIC_URL + record.route}
							  render={(props) => {
								  config.startQueueName = record.startQueueName;
								  setLogosByQueue(config, record.startQueueName);
								  return <>
									  {getStyleByQueue(config, record.startQueueName)}
									  <base target="_target"/>
									  <OdezaAppStandalone
										  {...props}
										  config={config}
										  startQueueName={record.startQueueName}
									  />
								  </>
							  }}
						/>
					})
				}
				{/*--- Main\Default route ---*/}
				{/*
				<Route path={process.env.PUBLIC_URL + "/:mrn?/:department?/:ref?/:username?"}
					   render={(props) => (
						   <OdezaAppStandalone
							   {...props}
							   config={config}
						   />
					   )}
				/>
				*/}
			</Switch>
		</Router>
	);
}

export default App;
